"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "event-chart"
  }, [_c("div", {
    staticStyle: {
      margin: "15px",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "flex-direction": "column"
    }
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-star"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon-small",
    attrs: {
      name: "star"
    }
  }), _c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "star"
    }
  }), _c("svg-icon", {
    staticClass: "card-panel-icon-small",
    attrs: {
      name: "star"
    }
  })], 1), _c("p", [_vm._v("Customer Review")])]), _c("el-table", {
    attrs: {
      data: _vm.list,
      border: "",
      "max-height": "220"
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "Client",
      width: "160",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.name) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Lead Status",
      width: "100",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.lastLeadStatus || "NEW") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Rating",
      width: "90",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return _vm._l(scope.row.rating, function (n) {
          return _c("i", {
            key: n,
            staticClass: "el-icon-star-on",
            staticStyle: {
              color: "#ffce00"
            }
          });
        });
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;